import {
  AtlasBodyMain,
  AtlasBodySubtitle,
  ConfirmationDialogMolecule,
  PageContentAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'

import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { CardImageMolecule } from 'components/molecule/CardImage.molecule'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { ProductQuantityOrganism } from 'components/organisms/ProductQuantity.organism'
import { MEASURE_LABELS_PLURAL } from 'utils/constants'
import { useProductForm } from './ProductForm.hook'

const ProductFormPage = () => {
  const { actions, product, total, dialogRef, quantities, loading } =
    useProductForm()

  if (!product) {
    return null
  }

  return (
    <>
      {loading && <LoaderAtom>Guardando</LoaderAtom>}

      <ToolbarMolecule
        title="Registrar cantidad"
        actionIcon="ic_arrow_back"
        onAction={actions.onGoBack}
      />

      <PageContentAtom>
        <StackAtom $direction="column" $gap={24}>
          <InstructionsMolecule
            ordered
            lines={[
              `Escribe la cantidad de ${
                MEASURE_LABELS_PLURAL[product.measureUnit]
              }.`,
              'Escanea la tarima.'
            ]}
          />

          <CardImageMolecule
            title={product.name}
            imageURL={product.imgUrl}
            textLines={[
              `UPC: ${product.barcode} | SKU: ${product.sku}`,
              `Unidad de medida: ${product.unitsOfMeasurment} unidades por caja`
            ]}
          />

          <ProductQuantityOrganism
            measureUnit={product.measureUnit}
            total={total}
            quantities={quantities}
            onAddQuantity={actions.onAddQuantity}
            onDeleteQuantity={actions.onDeleteQuantity}
          />
          <ScannerMolecule mode="hidden" onScan={actions.handleScanPallet} />
          <ConfirmationDialogMolecule
            confirmOnly
            dialogRef={dialogRef}
            confirmText="CERRAR"
            onConfirm={actions.onConfirmQuantity}
          >
            <StackAtom $direction="column" $gap={24}>
              <AtlasBodySubtitle>
                Cantidad menor a la pickeada
              </AtlasBodySubtitle>
              <AtlasBodyMain>
                Para concluir el registro del producto, debes ingresar la
                cantidad que fue pickeada.
              </AtlasBodyMain>
              <AtlasBodyMain>
                Revisa las demás tarimas de la solicitud.
              </AtlasBodyMain>
            </StackAtom>
          </ConfirmationDialogMolecule>
        </StackAtom>
      </PageContentAtom>
    </>
  )
}

export default ProductFormPage
